import styled from 'styled-components'

export const ContainerGoCadastro = styled.div`  
  margin-top: 16px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;